import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import CreatorCard from "./CreatorCard";
import { useSelector } from "react-redux";
import { getAllCreatorsData } from "../../../redux/slices/creatorSlice";
import useDebounce from "../../../hooks/useDebounce";
import { LineWave } from "react-loader-spinner";

export default function Creators() {
  const dispatch = useDispatch();
  const [query, setQuery] = useState("");
  const craetorData = useSelector((state) => state?.creators?.creatorsData);
  const loader = useSelector((state) => state?.creators?.isLoading);
  const debouncedSearch = useDebounce(query, 700);

  useEffect(() => {
    const payload = {
      searchVal: debouncedSearch,
    };
    dispatch(getAllCreatorsData(payload));
  }, [debouncedSearch]);

  return (
    <div>
      <h1 className="text-left text-white text-3xl font-bold  mb-4">
        Creators
      </h1>
      <div className="mb-3 text-left">
        <input
          type="text"
          placeholder="Search by Name and Company"
          className="bg-[#372F5B] h-10 px-4 py-2 pl-[35px] text-white rounded-full text-sm focus:outline-none w-full max-w-[400px]"
          name="search"
          value={query}
          onChange={(e) => setQuery(e.target?.value)}
        />
      </div>
      <div className="-mx-[15px] flex flex-wrap">
        {craetorData?.data?.length > 0 ? (
          craetorData?.data?.map((item) => (
            <CreatorCard key={item?._id} item={item} debouncedSearch={debouncedSearch}/>
          ))
        ) : (
          <p className="text-2xl text-white text-center font-bold">
            No Creators Found...
          </p>
        )}
      </div>
      {loader && (
        <div className="loader">
          <LineWave color={"#fff"} loading={loader} size={150} />
        </div>
      )}
    </div>
  );
}
